import * as React from "react";
import * as Styled from "./SocialShare.styled";

import ShareOnSocial from "react-share-on-social";
import { Share } from 'react-bootstrap-icons';

import './social-share.css';

export const SocialShare: React.FC = () => {

    const [share, setShare] = React.useState({
        textToShare: '',
        link: '',
        linkTitle: '',
        linkMetaDesc: ''
    });

    // get share values from the current page, if none use sensible/generic hard-coded values .
    // TODO: Possibly add fields to dashboard / options for client provided content to come down API.
    let shareText = "View our online VOD library content now!";
    let shareUrl = window.location.href;
    let shareTitle = document.getElementsByTagName("title")[0]?.innerText || "Check out our VOD content!";
    let shareDesc: any = document.querySelector("meta[name='description']");
    let shareOGDesc: any = document.querySelector("meta[property='og:description']");

    // use meta og:description if exists, use meta description if exists, otherwise canned default.
    shareOGDesc = shareOGDesc ? shareOGDesc[0]?.getAttribute('content') : "";
    shareDesc = (shareOGDesc && shareOGDesc !== '') ? shareOGDesc : (shareDesc && shareDesc.getAttribute('content') !== '') ? shareDesc.getAttribute('content') : "Check out our VOD content offerings online today.";

    React.useEffect(() => {
        setShare({
            textToShare: shareText,
            link: shareUrl,
            linkTitle: shareTitle,
            linkMetaDesc: shareDesc
        });
    }, [setShare, shareText, shareUrl, shareTitle, shareDesc]);

    return (
        <>
            <Styled.SocialShareWrapper className="social-share">
                <ShareOnSocial
                    textToShare={share.textToShare}
                    link={share.link}
                    linkTitle={share.linkTitle}
                    linkMetaDesc={share.linkMetaDesc}
                    linkFavicon=""
                    noReferer>
                    <button
                        className="align-items-center"
                        style={{ backgroundColor: 'transparent', fontSize: '0.75rem', color: '', border: '0 none' }}
                        title="Share This Content">
                        <span>SHARE</span> <Share style={{ marginLeft: '0.25rem' }} />
                    </button>
                </ShareOnSocial>
            </Styled.SocialShareWrapper>
        </>
    );
};